<template>
  <div>
    <slot name="table-top"></slot>

    <l-table-view v-if="pData && pData.Records" :DataArr="pData.Records" :TableConfig="TableConfig"></l-table-view>

    <slot name="table-end"></slot>

    <template v-if="pData && pData.Records && isShowPagination">
      <el-pagination
        style="margin-top: 15px;margin-bottom:40px;"
        @size-change="onPageSizeChange"
        @current-change="onPageChange"
        :current-page="currentPage"
        :page-sizes="currentPageSizeOpts"
        :page-size="currentPageSize"
        layout="total, prev, pager, next,sizes,jumper"
        :total="pData.TotalCount"
      ></el-pagination>
    </template>
  </div>
</template>

<script>
var isType = false;
import gets from "@/model/language.js";

/*var tdata = [
    {
        title: '', value: '', forSelect: '', type: 'String'
    }]
*/

export default {
  // props: ["resultData", "TableConfig",],
  props: {
    resultData: {
      type: [String, Array, Object,Function,Symbol]
    },
    TableConfig: {
      type: [String, Array, Object,Function,Symbol]
    },
    isShowPagination: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentValue: Object,
      currentPageSize: this.TableConfig.PageSize
        ? this.TableConfig.PageSize
        : 20,
      currentPageSizeOpts: this.TableConfig.PageSizeOpts
        ? this.TableConfig.PageSizeOpts
        : [20, 50, 100, 200, 300,500],
      currentPage:
        this.pData && this.pData["PageIndex"] ? this.pData.PageIndex : 1,
      IsNUll: this.pData && this.pData.Records,
    
    };
  },
  created() {
    this.TableConfig.TableRowButtons();
  },
  computed: {
    pData() {
      return this.resultData && this.resultData.data
        ? this.resultData.data
        : this.resultData;
    }
  },
  methods: {
    gets: gets,
    onPageChange(page) {
      if (this.currentPage != page) {
        this.currentPage = page;

        if (this.TableConfig.OnPageChange) {
          this.TableConfig.OnPageChange(page, this);
        }

        this.$emit("on-page-change", page);
      }
    },
    onPageSizeChange(pageSize) {
      if (this.currentPageSize != pageSize) {
        this.currentPageSize = pageSize;
        if (this.TableConfig.OnPageSizeOpts) {
          this.TableConfig.OnPageSizeOpts(pageSize, this);
        }

        this.$emit("on-page-size-change", pageSize);
      }
    }
  },
  watch: {
    resultData: function() {
      this.currentPage =
        this.pData && this.pData["PageIndex"] ? this.pData.PageIndex : 1;
      this.IsNUll = this.pData && this.pData.Records;
    }
  }
};
</script>






// WEBPACK FOOTER //
// table_page_view.vue?6270aede